<template>
  <div class="home">
    <div class="home-wrap">
      <h1>Welcome to the Exflow Cloud Onboarding Portal!</h1>
      <p>On this page you can deploy and manage Exflow Cloud Web installations.</p>

      <h3>To deploy a new Web:</h3>
      <p>Go to the "Register" tab and fill in the necessary information.</p>
      <p>Once you've completed the form, press "Submit" to create a new request.</p>
      <p> The request will immediately be sent to our Automation Process to create the Web Application.</p>

      <p>A deployment status will be shown for you to verify that the deployment is Processing, Completed or Failed.
        The CorrelationId is for Signups use if there were any issues during deployment, please email this ID to <a href="https://www.signupsoftware.com/support/" target="_blank">https://www.signupsoftware.com/support/</a> if you receive a "Failed" status for the job.</p>

      <p> When the Job has completed, view the new deployment under the tab "List", select the customer by pressing "Edit".</p>

      <p>Here you will find the necessary information to connect to the new site.</p>
      
      <h3>New Features:</h3>
      <h4>Vnext Migration</h4>
      <p><a href="https://docs.exflow.cloud/web/docs/migrate" target="_blank">Read more about migration</a></p>

      <h4>New Actions</h4>
      <ol>
        <li><b>Delete</b>: This action completely removes the web application from the system. It's like permanently erasing it, and you won't be able to recover it afterward.</li>
        <li><b>Restart</b>: Restarting the web app means stopping it and then starting it again. It's like turning it off and on again. This action is currently only supported before the migration process.</li>
        <li><b>Migrate</b>: This action moves the web application from its current platform to a new one. It typically takes a few minutes to complete the migration process.</li>
        <li><b>Postpone migration</b>: This action delays the migration process for the web application. It sets the status to "postpone," meaning it won't be automatically migrated during the initial waves of migration. It can still be migrated manually later.</li>
      </ol>

      <h4>Regarding the statuses shown in the portal:</h4>
       <ul>
        <li><b>Ready</b>: Indicates that the web app is prepared and ready to be migrated.</li>
        <li><b>(!)</b>: Indicates that action is required from the partner to fill in necessary information. The slider is used to determine if the web app is a Production or Non-Production instance.</li>
        <li><b>Postponed</b>: Shows that the migration for this web app is delayed and won't happen automatically in the initial waves.</li>
        <li><b>vNext</b>: Indicates that the web app has already been deployed as or migrated to the new version.</li>
       </ul>
      <h4>Azure AD Authentication</h4>

      <p>When deploying new customers you now have the option of selecting the authentication methods the user have to use to access the web application.</p>

      <p>The options are Ticket and AAD (Azure AD).</p>

      <p><span>Ticket:</span> When Ticket is configured the users will log in by filling out their email address and receiving a One Time Password sent to their mailbox.</p>

      <p>This is the recommended method for On-Premise customers.</p>

      <p><span>AAD: </span>When using Azure AD the user will log in using their Azure AD company account.</p>

      <p>With AAD configured the user will have to consent to the application logging them in by creating a service principal in their Azure AD.</p>

      <p>Depending on the customers Azure AD setup the application might have to be consented by an Administrator. If this is the case the login screen will prompt for it.</p>

      <h4>View Exceptions</h4>

      <p>In the Edit mode of a deployment we’ve added a button called “View Exceptions”</p>

      <p>Use this to view exceptions that have been caught by the web application within the last 24 hours.</p>

      <p>This is useful to troubleshoot for information when a customer is having issues in the web.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
}
</script>

<style scope>
.home,
.home-wrap {
  display: flex;
  width: 100%;
}
.home-wrap {
  margin: 0 auto;
  padding: 10px;
  width: 100%;
  flex-direction: column;
  background-color: var(--o-text-on-bg);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--o-primary) var(--o-bg1);
}
.home-wrap::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.home-wrap::-webkit-scrollbar-track{
  background-color: var(--o-bg1);
}
.home-wrap::-webkit-scrollbar-thumb{
  background-color: var(--o-primary);
}
.home-wrap h1, .home-wrap h3, .home-wrap h4{
  font-weight: 400; 
  color: var(--o-text);
}
.home-wrap h3 {
  border-top: 1px solid var(--o-text);
  padding-top: 10px;
  font-size: 22px;
}
.home-wrap h4{
  margin: 0;
  padding: 7px 0;
}
.home-wrap p {
  color: var(--o-text-on-bg1);
  font-size: 15px;
  margin: 0;
  padding: 7px 0;
}
.home-wrap p span{
  font-weight: 600;
  color: var(--o-text);
}
ul li, ol li {
  padding-bottom: 5px;
}
/* ================================= 
  Media Queries
==================================== */
@media (min-width: 769px) {
  .home-wrap {
    max-width: 820px;
    max-height: 500px;
    padding: 40px;
  }
}
@media (min-width: 1025px) {
  .home-wrap {
    max-width: 820px;
    max-height: 600px;
    padding: 40px;
  }
}
</style>